<template>
  <div class="wrapper">
    <app-loader v-if="isFetching" />
    <template v-else>
      <not-found v-if="!hasItems" />
      <template v-else>
        <div>
          <div class="recommend-header">{{ $t('common.recommendMenu') }}</div>
          <menu-list :items="items" :column="2" />
        </div>
      </template>
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import MenuList from '@/components/menuList/MenuList'
import AppLoader from '@/components/loader/AppLoader'
import NotFound from '@/components/error/NotFound'
export default {
  components: {
    MenuList,
    AppLoader,
    NotFound,
  },
  data() {
    return {
      isFetching: true,
      items: [],
    }
  },
  computed: {
    ...mapGetters({
      hasRecommends: 'scheduledRecommend/hasRecommends',
      recommends: 'scheduledRecommend/getRecommends',
      getExistRecommendsById: 'scheduledRecommend/getExistRecommendsById',
      getItemByItemCode: 'menu/getItemByItemCode',
      language: 'setting/getLanguage',
    }),
    id() {
      const idStr = this.$route.params.adId
      try {
        const id = Number(idStr)
        return id
      } catch (err) {
        return ''
      }
    },
    hasItems() {
      return !!this.items.length
    },
  },
  watch: {
    recommends() {
      this.init()
    },
    language() {
      this.$emit('updateHead')
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (!this.hasRecommends) return
      this.isFetching = false
      const recommend = this.getExistRecommendsById(this.id)
      if (this.id === '' || !recommend) return
      this.items = recommend.itemList.map((item) => this.getItemByItemCode(item.itemCode))
    },
    handleClick() {
      this.$router.push({ name: 'shopMenu' })
    },
  },
  head: {
    title() {
      return {
        inner: this.$t(`pageTitle.${this.$route.name}`),
        complement: this.$t('siteId'),
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.wrapper {
  height: 100%;
  overflow-x: hidden;
  background-color: #fff;

  .h3 {
    margin: 2rem 0;
  }
}
.recommend-header {
  width: 100%;
  max-width: 100vw;
  height: 40px;
  background-color: #fff;
  line-height: 40px;
  margin-bottom: 10px;
  border-bottom: solid 2px #e5e4e2;
}
</style>
